<template>
  <section class="calibration">
    <b-row class="calibration__search search">
      <b-col class="search__quest">
        <div class="search__input">
          <p class="search__input-text">
            Enter inventory number, guid or bims id
          </p>
          <b-row>
            <b-form-input
              class="search__input-form"
              @keyup.enter="search()"
              v-model="searchValue"
              placeholder="-- Enter --"
            ></b-form-input>
            <b-button class="search__input-button" @click="search()"
              >Search
            </b-button>
          </b-row>
        </div>
        <div v-if="equipment !== undefined" class="search__name">
          <img class="search__img" :alt="equipment.name" :src="equipment.img" />
          <h1 v-if="equipment" class="search__full-name">
            {{ equipment.name }} ({{ equipment.serialNumber }})
          </h1>
        </div>
        <div v-if="equipment" class="search__report">
          <b-form-select
            class="search__input-report"
            v-model="selected"
            :options="options"
          >
            <template v-slot:first>
              <b-form-select-option :value="null" disabled
                >-- Please select an option --</b-form-select-option
              >
            </template>
          </b-form-select>
          <b-form-radio-group
            v-model="selectedRadio"
            :options="optionsRadio"
            value-field="item"
            text-field="name"
          ></b-form-radio-group>
          <b-button class="search__generate-button">Generate report</b-button>
        </div>
      </b-col>

      <b-col v-if="equipment !== undefined" class="search__info">
        <aside class="search__info-wrap">
          <p>
            <span class="search__info-title">Тип оборудования:</span>
            <span class="search__info-content">{{ equipment.type }}</span>
          </p>
          <p>
            <span class="search__info-title">Статус:</span>
            <span class="search__info-content">{{ equipment.status }}</span>
          </p>
          <p>
            <span class="search__info-title">Изготовитель:</span>
            <span class="search__info-content">{{
              equipment.manufacturer
            }}</span>
          </p>
          <p>
            <span class="search__info-title">Модель:</span>
            <span class="search__info-content">{{ equipment.model }}</span>
          </p>
          <p>
            <span class="search__info-title"
              >Ответственное подразделение (ремонт):</span
            >
            <span class="search__info-content">{{
              equipment.responsibleSubdivision
            }}</span>
          </p>
          <p>
            <span class="search__info-title"
              >Эксплуатирующее подразделение:</span
            >
            <span class="search__info-content">{{
              equipment.exploitingSubdivision
            }}</span>
          </p>
          <p>
            <span class="search__info-title">МОЛ:</span>
            <span class="search__info-content">{{ equipment.mol }}</span>
          </p>
          <p>
            <span class="search__info-title">Территория:</span>
            <span class="search__info-content">{{ equipment.territory }}</span>
          </p>
          <p>
            <span class="search__info-title">Серийный номер:</span>
            <span class="search__info-content">{{
              equipment.serialNumber
            }}</span>
          </p>
          <p>
            <span class="search__info-title">GUID:</span>
            <span class="search__info-content search__info-content--blue">{{
              equipment.guid
            }}</span>
          </p>
          <p>
            <span class="search__info-title">Bims ID:</span>
            <span class="search__info-content search__info-content--blue">{{
              equipment.bimsID
            }}</span>
          </p>
          <p>
            <span class="search__info-title">Tam:</span>
            <span class="search__info-content search__info-content--blue">{{
              equipment.tam
            }}</span>
          </p>
        </aside>
      </b-col>
    </b-row>

    <b-row v-if="equipment !== undefined" class="calibration__report report">
      <h2 class="report__heading">Calibration report</h2>
      <b-table-simple hover responsive>
        <b-thead>
          <b-tr>
            <b-th class="report__title">Data</b-th>
            <b-th class="report__title">Used buffer solutions</b-th>
            <b-th class="report__title">Slope, % <br />Norm 95-105</b-th>
            <b-th class="report__title">Offset, mV <br />Norm ±(0-20)</b-th>
            <b-th class="report__title">User</b-th>
          </b-tr>
        </b-thead>
        <b-tbody v-for="(report, index) in reports" :key="index">
          <b-tr>
            <b-td class="report__date">{{ report.date }}</b-td>
            <b-td class="report__ubs"
              ><p
                v-for="(solution, solutionIndex) in report.ubs"
                :key="solutionIndex"
              >
                {{ solution }}
              </p></b-td
            >
            <b-td
              class="report__slope"
              :class="{ report__normStatus: checkStatusSlope(report.slope) }"
              >{{ report.slope }}</b-td
            >
            <b-td
              class="report__offset"
              :class="{ report__normStatus: checkStatusOffset(report.offset) }"
              >{{ report.offset }}</b-td
            >
            <b-td class="report__user">{{ report.user }}</b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </b-row>
  </section>
</template>

<script>
// Так-как данных немного - не стала выносить их в отдельный файл
const EQUIPMENTS = [
  {
    name: "Аналитические весы OHAUS Adventurer АХ324",
    type: "Весы",
    status: "Готов к работе",
    manufacturer: "Ohaus",
    model: "AX-123",
    responsibleSubdivision: "Группа обслуживания лабораторного оборудования",
    exploitingSubdivision: "Химико-аналитическая лаборатория 2.0",
    mol: "Иванов Иван Иванович",
    territory: "г. Санкт-Петербург (Нойдорф)",
    serialNumber: "B715976163",
    guid: "508b2a71-662e-4983-ae0c-3cb0c1cd21c5",
    bimsID: "49db8db1-585f-4b9e-bbf0-8a59698edc8b",
    tam: "А-001234",
    img: require("../assets/equipment.svg")
  }
];

const REPORTS = {
  "А-001234": [
    {
      date: "04.10.19 10:23",
      ubs: [
        "В1: № 2000460789536: pH 1.09",
        "В2: № 2000460789536: pH 2.00",
        "В3: № 2000460789536: pH 4.01",
        "В4: № 2000460789536: pH 7.00",
        "В5: № 2000460789536: pH 9.21"
      ],
      slope: 98.7,
      offset: -0.3,
      user: "Иванов Генадий Петрович"
    },
    {
      date: "04.10.19 10:23",
      ubs: [
        "В1: № 2000460789536: pH 1.09",
        "В2: № 2000460789536: pH 2.00",
        "В3: № 2000460789536: pH 4.01",
        "В4: № 2000460789536: pH 7.00",
        "В5: № 2000460789536: pH 9.21"
      ],
      slope: 98.7,
      offset: -0.3,
      user: "Петров Иван Генадьевич"
    },
    {
      date: "04.10.19 10:23",
      ubs: [
        "В1: № 2000460789536: pH 1.09",
        "В2: № 2000460789536: pH 2.00",
        "В3: № 2000460789536: pH 4.01",
        "В4: № 2000460789536: pH 7.00",
        "В5: № 2000460789536: pH 9.21"
      ],
      slope: 98.7,
      offset: -0.3,
      user: "Петров Генадий Иванович"
    },
    {
      date: "04.11.19 10:23",
      ubs: [
        "В1: № 2000460789536: pH 1.09",
        "В2: № 2000460789536: pH 2.00",
        "В3: № 2000460789536: pH 4.01",
        "В4: № 2000460789536: pH 7.00",
        "В5: № 2000460789536: pH 9.21"
      ],
      slope: 90.1,
      offset: -0.5,
      user: "Генадьев Иван Петрович"
    }
  ]
};
export default {
  name: "Calibration",
  data() {
    return {
      equipment: "",
      reports: REPORTS,
      searchValue: "А-001234",
      selected: "1 month",
      options: [
        { value: "1 day", text: "1 day" },
        { value: "1 month", text: "1 month" },
        { value: "3 months", text: "3 months" }
      ],
      selectedRadio: "A",
      optionsRadio: [
        { item: "A", name: "Calibration" },
        { item: "B", name: "Measuring" },
        { item: "C", name: "Using" }
      ],
      fields: [
        { key: "data", sortable: true },
        "used_buffer_solutions",
        { key: "slope", sortable: true },
        "offset",
        "user"
      ]
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    search() {
      this.equipment = undefined;
      EQUIPMENTS.forEach(equipment => {
        if (
          equipment.tam.toLowerCase() === this.searchValue.toLowerCase() ||
          equipment.guid.toLowerCase() === this.searchValue.toLowerCase() ||
          equipment.bimsID.toLowerCase() === this.searchValue.toLowerCase()
        ) {
          this.equipment = equipment;
          this.reports = REPORTS[equipment.tam];
        }
      });
    },
    checkStatusSlope(slope) {
      if (slope >= 95 && slope <= 105) return true;
    },
    checkStatusOffset(offset) {
      if (offset >= -20 && offset <= 20) return true;
    }
  }
};
</script>

<style lang="scss">
.calibration {
  padding: 30px 50px 106px 50px;
}

.search {
  width: 100%;
  &__quest {
    flex-grow: 0.64;
  }

  &__input {
    margin-bottom: 33px;
  }

  &__input-text {
    letter-spacing: 0.16px;
    font-feature-settings: "pnum" on, "lnum" on;
    color: #8c8c8c;
  }

  &__input-form {
    width: 21vw;
    height: 32px;

    border: 1px solid #e9e9e9;
    box-sizing: border-box;
    border-radius: 0;

    padding: 0px 12px;
    margin-right: 20px;
    margin-top: 5px;

    &:focus {
      border: 1px solid #e9e9e9;
      box-shadow: none;

      color: #353535;
    }
  }

  &__input-button {
    width: 90px;
    height: 40px;

    background: #353535;
    border-radius: 3px;

    font-weight: 500;
    font-size: 14px;
    line-height: 24px;

    color: #ffffff;
  }

  &__name {
    display: flex;

    width: 90%;
    margin-bottom: 34px;
  }

  &__img {
    width: 40px;
    height: 40px;
    padding-top: 8px;

    margin-right: 20px;
  }

  &__full-name {
    font-weight: 500;
    font-size: 20px;
    letter-spacing: 0.5px;

    color: #353535;
  }

  &__input-report {
    width: 63%;
    height: 32px;

    padding: 0px 12px;

    border: 1px solid #e9e9e9;
    border-radius: 0;
    color: #353535;
    background: #fff url("../assets/triangle.svg") no-repeat right 10px
      center/8px 10px;

    margin-bottom: 15px;
    cursor: pointer;

    &:focus {
      border: 1px solid #e9e9e9;
      box-shadow: none;

      color: #353535;
    }
  }

  &__generate-button {
    margin-top: 48px;

    width: 180px;
    height: 40px;

    background: #4990e2;
    border-radius: 3px;

    font-weight: 500;
    font-size: 14px;

    &:hover {
      opacity: 0.8;
      background: #4990e2;
    }
  }

  &__info {
    display: flex;
    height: auto;

    margin-left: 30px;
    align-items: flex-end;
  }

  &__info-wrap {
    width: 100%;
    background: #f7f7f7;
    border-radius: 5px;
    padding: 26px 18.38px;

    p {
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
      color: #8c8c8c;

      margin-bottom: 6px;
    }
  }

  &__info-content {
    padding-left: 4px;
    color: #353535;

    &--blue {
      color: #4990e2;
    }
  }
}

.report {
  margin-top: 46px !important;
  padding: 40px;
  background: #ffffff;

  border: 1px dashed #939da6;
  box-sizing: border-box;
  box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.15);
  overflow: auto;

  &__heading {
    font-size: 16px;
    line-height: 19px;

    color: #000000;
  }

  &__title {
    padding: 20px 20px 0px 0px !important;

    vertical-align: top !important;
    border: none !important;
    white-space: pre;

    font-size: 13px;
    font-weight: normal;
    line-height: 15px;

    color: #939da6;
  }

  &__date {
    font-size: 16px;
    line-height: 19px;

    color: #353535;
  }

  &__ubs {
    white-space: pre;

    font-size: 13px;
    line-height: 17px;
    padding-bottom: 15px !important;

    color: #353535;
  }

  &__user {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;

    color: #353535;
  }

  &__slope {
    font-size: 13px;
    line-height: 15px;

    color: #353535;

    &:after {
      content: url("../assets/bad.svg");
      width: 16px;
      height: 16px;
      padding-left: 20px;
    }
  }

  &__offset {
    font-size: 13px;
    line-height: 15px;

    color: #353535;

    &:after {
      content: url("../assets/bad.svg");
      width: 16px;
      height: 16px;
      padding-left: 20px;
    }
  }

  &__normStatus:after {
    content: url("../assets/good.svg");
  }
}

.custom-control-inline {
  display: flex;
  flex-direction: column;
}
.custom-control-label {
  cursor: pointer;

  font-size: 14px;

  padding-top: 2px;
  padding-left: 10px;
  vertical-align: bottom;
  margin-bottom: 6px;
  &::before {
    background: #ffffff;
    border: 2px solid #c1c1c1 !important;
    height: 20px;
    width: 20px;
  }
}
.custom-radio .custom-control-input:checked ~ .custom-control-label {
  &::before {
    background: #ffffff;
    border: 2px solid #c1c1c1 !important;
    height: 20px;
    width: 20px;
  }
  &::after {
    width: 10px;
    height: 10px;

    margin: 5px;

    background-image: none;
    background: #4990e2;
    border-radius: 50%;
  }
}
.table th,
.table td {
  padding: 20px 35px 20px 0;

  border-top: 0px solid #dee2e6 !important;
}

.table tbody + tbody {
  border-top: 1px dashed #e9e9e9;
}

@media (min-width: 1440px) {
  .report {
    margin-top: 96px !important;
  }
}

@media (max-width: 881px) {
  .search__input-form {
    width: 100% !important;
    margin-bottom: 16px;
  }
}

@media (max-width: 650px) {
  .search__quest {
    width: 100%;
    flex-grow: 1;
    margin-bottom: 40px;
  }

  .search__input-form {
    width: 60% !important;
    margin-bottom: 0px;
  }

  .search__info {
    margin-left: 0px;
    flex-basis: auto;
  }
}

@media (max-width: 450px) {
  .calibration {
    padding: 30px 15px !important;
  }
}
</style>
